/** Boing Express on the Chrome Web Store (public listing). */
export const CHROME_EXTENSION_STORE_URL =
  'https://chromewebstore.google.com/detail/boing-express/hhknjdhknnghccmfnfafbkapjljicbfh';
